import { createContext } from 'react';

const curriculumContext = createContext();

export default curriculumContext;